import React from 'react';
import ModuleAvailability from '../../components/business/ModuleAvailability';

export const DevelopmentOverviewPage = () => (
    <ModuleAvailability
        title="开发与培育"
        description="覆盖名单准入、开发周期、培育计划、邮件内容、发送批次和触达记录。"
        available={[
            '客户信号查询与人工分诊',
            'HTML 邮件模板创建、导入与安全预览',
            '手工发送名单、资格检查与冻结',
            '发送批次、预检、确认、控制与单人重发',
        ]}
        pending={[
            '待治理池',
            '开发周期',
            '培育计划',
            '模板测试与发布',
            'Excel/CSV 导入服务端 Worker',
            '真实邮件服务商与回复监控 Worker',
        ]}
    />
);
export const ResourceOverviewPage = () => (
    <ModuleAvailability
        title="合作资源"
        description="集中管理渠道、讲师 / 顾问、资料库及合作结算。"
        available={[]}
        pending={[
            '渠道主档',
            '渠道提成规则',
            '讲师 / 顾问主档',
            '费用规则',
            '受控资料库',
            '合作结算',
        ]}
    />
);
export const SettingsOverviewPage = () => (
    <ModuleAvailability
        title="系统管理"
        description="维护用户权限、字典、模板、导入、审计和系统配置。"
        available={['审计日志查询', '异步任务查询 / 取消', '邮箱回复监控前端入口']}
        pending={['V2 会话与 MFA', '用户与角色', '业务字典', '邮箱监控服务端', '导入批次 Worker', '配置发布']}
    />
);
